import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FooterHelpLinksComponent } from '~app/core/footer/footer-help-links/footer-help-links.component'
import { FtrLogoModule } from '~app/core/logo/ftr/ftr-logo.module'
import { FooterAdminComponent } from './footer-admin/footer-admin.component'
import { FooterDisclaimerComponent } from './footer-disclaimer/footer-disclaimer.component'
import { FooterLoggedInComponent } from './footer-logged-in/footer-logged-in.component'
import { FooterLoggedOutComponent } from './footer-logged-out/footer-logged-out.component'
import { FooterComponent } from './footer.component'

@NgModule({
  imports: [CommonModule, FtrLogoModule, RouterModule],
  declarations: [
    FooterComponent,
    FooterLoggedOutComponent,
    FooterDisclaimerComponent,
    FooterLoggedInComponent,
    FooterAdminComponent,
    FooterHelpLinksComponent,
  ],
  exports: [FooterComponent],
})
export class FooterModule {}
